import { $, $$, isMobile, isTablet, sliderConfig } from '@utils';
import Swiper from 'swiper';
import { Navigation, Scrollbar, FreeMode, A11y } from 'swiper/modules';

function init() {
  if (!$('[data-au-loyality]')) return;

  initSliders();
  isMobile.addEventListener('change', () => initSliders());
  isTablet.addEventListener('change', () => initSliders());
}

function initSliders() {
  $$('[data-au-loyality-slider]').forEach((slider) => {
    const section = slider.closest('[data-au-loyality]');
    const isFiveItems = section && section.classList.contains('au-loyality--5');
    const breakpoint = isFiveItems ? isTablet : isMobile;

    if (breakpoint.matches) {
      createSwiper(slider);
    } else {
      destroySwiper(slider);
    }
  });
}

function createSwiper(sliderEl) {
  if (sliderEl._swiper) return;

  sliderEl._swiper = new Swiper(sliderEl, {
    modules: [Navigation, Scrollbar, FreeMode, A11y],
    ...sliderConfig,
    spaceBetween: 0,
    freeMode: false,
  });
}

function destroySwiper(sliderEl) {
  if (!sliderEl._swiper) return;

  sliderEl._swiper.destroy(true, true);
  sliderEl._swiper = null;
}

export default { init };
